import DefaultLayout from '@/layouts/DefaultLayout.vue'

const Projects = () => import('@/pages/merch/project/Projects.vue')
const PersonalAccount = () => import('@/pages/merch/personalAccount/PersonalAccount.vue')
const PersonalData = () => import('@/pages/merch/personalAccount/PersonalData.vue')
const ChooseMonth = () => import('@/pages/merch/personalAccount/MonthOfActs.vue')
const Act = () => import('@/pages/merch/personalAccount/Act.vue')
const ChooseYear = () => import('@/pages/merch/personalAccount/ChooseYear.vue')
const Agreement = () => import('@/pages/merch/personalAccount/Agreement.vue')
const ChooseAgreementMonth = () => import('@/pages/merch/personalAccount/MonthOfAgreement.vue')
const ChooseAgreementYear = () => import('@/pages/merch/personalAccount/ChooseAgreementYear.vue')


export default {
    path: '/personalAccount',
    component: DefaultLayout,
    children: [
    {
        path: '',
        component: Projects,
        children: [
          {
            path: '',
            name: 'Личный кабинет',
            meta: {
              label: "Личный кабинет",
              title: "Личный кабинет"
            },
            component: PersonalAccount
          },
          {
            path: 'personalData',
            name: 'Личные данные',
            meta: {
              label: "Личные данные",
              title: "Личные данные",
               breadcrumb: [
                { name: 'Личный кабинет', link: '/personalAccount' }
              ],
            },
           
            component: PersonalData
          },

          {
            path: 'agreementYears',
            name: 'Выбор года',
            meta: {
              label: "Выбор года",
              title: "Выбор года",
               breadcrumb: [
                { name: 'Личный кабинет', link: '/personalAccount' }
              ],
            },
           
            component: ChooseAgreementYear
          },
          {
            path: 'agreementYears/:year/months',
            name: 'Выбор месяца',
            meta: {
              label: "Выбор месяца",
              title: "Выбор месяца",
               breadcrumb: [
                { name: 'Выбор года', link: '/years' }
              ],
            },
            component: ChooseAgreementMonth,
            props: true
          },
          
          {
            path: 'agreementYears/:year/months/:mid/agreement',
            name: 'Договор',
            meta: {
              label: "Договоры",
              title: "Договоры",
               breadcrumb: [
                { name: 'Выбор месяца', link: 'years/:year/months' }
              ],
            },
            component: Agreement,
            props: true
          },
          
          {
            path: 'years',
            name: 'Выбор года',
            meta: {
              label: "Выбор года",
              title: "Выбор года",
               breadcrumb: [
                { name: 'Личный кабинет', link: '/personalAccount' }
              ],
            },
           
            component: ChooseYear
          },
          {
            path: 'years/:year/months',
            name: 'Выбор месяца',
            meta: {
              label: "Выбор месяца",
              title: "Выбор месяца",
               breadcrumb: [
                { name: 'Выбор года', link: '/years' }
              ],
            },
            component: ChooseMonth,
            props: true
          },
          
          {
            path: 'years/:year/months/:mid/acts',
            name: 'Акты',
            meta: {
              label: "Акты",
              title: "Акты",
               breadcrumb: [
                { name: 'Выбор месяца', link: 'years/:year/months' }
              ],
            },
            component: Act,
            props: true
          },
        ]
    }
  ]
}